import React from 'react';
import AppRouter from '../../routes/router';
import './Main.scss';

export default function Main() {
  return (
    <main className="main-content">
      <AppRouter />
    </main>
  );
}